import Loading from '../../../shared/Loading/Loading';
import Ranking from '../hooks/Ranking';

const RankingIcon = ({ compact = false }) => (
  <div className={`${compact ? 'h-9 w-9 bg-purple-200 text-personalized' : 'h-10 w-10 bg-purple-500 text-white'} flex shrink-0 items-center justify-center rounded-full`}>
    <svg className={`${compact ? 'h-8 w-8' : 'h-8 w-8'} translate-x-[0.5px] translate-y-[0.5px]`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3.35 13.7 5.65 16.5 5.05 17.05 7.85 19.75 8.8 18.35 11.3 19.75 13.8 17.05 14.75 16.5 17.55 13.7 16.95 12 19.25 10.3 16.95 7.5 17.55 6.95 14.75 4.25 13.8 5.65 11.3 4.25 8.8 6.95 7.85 7.5 5.05 10.3 5.65 12 3.35Z" stroke="currentColor" strokeWidth="1.55" strokeLinejoin="round" />
      <circle cx="12" cy="11.3" r="4.25" stroke="currentColor" strokeWidth="1.55" />
      <path d="m9.65 11.35 1.55 1.55 3.15-3.25" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

const ContactRanking = ({ user, logout, message, variant = 'card' }) => {
  const vm = Ranking({
    userId: user?.Id,
    logout,
    message
  });

  if (variant === 'inline') {
    return (
      <div className="profile-ranking-inline flex min-w-0 items-center justify-center gap-2">
        <RankingIcon compact />
        <div className="min-w-0">
          <p className="mb-0.5 whitespace-nowrap text-xs leading-none text-gray-500">Posici&oacute;n Ranking</p>
          {vm.loading ? (
            <div className="flex py-1">
              <Loading size="5" colorBase="white" colorAccent="personalized" double={true} bold="4" />
            </div>
          ) : (
            <p className="text-[1.8rem] font-bold leading-none text-gray-700">{vm.position}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <section className="profile-ranking-card rounded-lg border border-gray-200 bg-white px-3 py-2.5 shadow-sm">
      <div className="flex items-center gap-3">
        <RankingIcon />
        <div className="min-w-0 flex-1">
          {vm.loading ? (
            <div className="flex py-1">
              <Loading size="6" colorBase="white" colorAccent="personalized" double={true} bold="4" />
            </div>
          ) : (
            <p className="text-2xl font-bold leading-none text-gray-700">{vm.position}</p>
          )}
          <p className="mt-1 text-xs leading-none text-gray-500">Posici&oacute;n Ranking</p>
        </div>
      </div>
      {!vm.loading && (
        <div className="mt-2.5 flex flex-wrap items-center justify-between gap-x-3 gap-y-1 border-t border-gray-100 pt-1.5 text-[10px] text-gray-500">
          <span>Ultima actualizaci&oacute;n</span>
          <span className="text-right">{vm.dateUpdate || 'Pendiente'}</span>
        </div>
      )}
    </section>
  );
};

export default ContactRanking;
